import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { Search } from '@material-ui/icons'
import { Grid, FormControl, InputLabel, Select, MenuItem, TextField, FormControlLabel, Checkbox, Button, Divider } from '@material-ui/core'
import * as utils from '@utils'
import { API } from '@const'
import Table from '@tables/table'
import { PfSubPfSelect, DateSelect } from '@select'

const COMPONENT_GROUP = 'member_login_history'

class MemberLoginHistoryPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'MemberLoginHistoryPage')
        }
    }

    state = {
        searchType: 'platform',
        pfAccount: '',
        ip: '',
        device: 'all',
        isFilterNonDuplicatedIP: true,
        isLoading: false,
    }

    options = {
        export: false,
        orderDirection: 'desc',
    }
    columns = [
        {
            field: 'pf_sub_pf_id',
            type: 'platform',
        },
        {
            field: 'pf_account',
        },
        {
            field: 'origin_account',
        },
        {
            field: 'ip',
        },
        {
            field: 'device',
            translate: {
                dataKey: 'device',
                tranKey: 'Device',
            },
        },
        {
            field: 'created_at',
            type: 'datetime',
        },
    ]

    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.export')) {
            this.options.export = true
        }
    }

    queryData = () => {
        this.table.SetLoading(true)
        this.setState({ isLoading: true })

        utils.apiRequest(
            'get',
            API.PLAYER_LOGIN_HISTORY_LIST,
            {
                start_at: utils.datetimeToUnix_startOf(this.dateSelect.state.startDate, 'day'),
                end_at: utils.datetimeToUnix_endOf(this.dateSelect.state.endDate, 'day'),
                pf_id: this.state.searchType === 'platform' && this.pfSelect.state.pfId !== 'all' ? this.pfSelect.state.pfId : '',
                pf_sub_pf_id: this.state.searchType === 'platform' && this.pfSelect.state.pfSubPfId !== 'all' ? this.pfSelect.state.pfSubPfId : '',
                pf_account: this.state.searchType === 'account' ? this.state.pfAccount : '',
                ip: this.state.searchType === 'ip' ? this.state.ip : '',
                device: this.state.device !== 'all' ? this.state.device : '',
                searchType: this.state.searchType,
                isFilterNonDuplicatedIP: this.state.isFilterNonDuplicatedIP,
            },
            (data) => {
                if (this.state.searchType === 'platform' && this.state.isFilterNonDuplicatedIP) {
                    const ipPfAccountMap = {}
                    data.forEach((elem) => {
                        if (!ipPfAccountMap[elem.ip]) ipPfAccountMap[elem.ip] = []

                        if (!ipPfAccountMap[elem.ip].includes(elem.pf_account)) ipPfAccountMap[elem.ip].push(elem.pf_account)
                    })

                    data = data.filter((elem) => ipPfAccountMap[elem.ip].length > 1)
                }

                this.table.SetData(data)
                this.setState({ isLoading: false })
            },
            (_err) => {
                this.table.SetData([])
                this.setState({ isLoading: false })
            },
            true
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl className={this.props.classes.formControl} style={{ minWidth: '120px' }}>
                        <InputLabel htmlFor="age-simple">{this.t('searchType')}</InputLabel>
                        <Select
                            value={this.state.searchType}
                            onChange={(event) => {
                                this.setState({
                                    searchType: event.target.value,
                                })
                            }}>
                            <MenuItem value="platform">{this.t('platform')}</MenuItem>
                            <MenuItem value="account">{this.t('account')}</MenuItem>
                            <MenuItem value="ip">{this.t('ip')}</MenuItem>
                        </Select>
                    </FormControl>
                    {this.state.searchType === 'platform' ? (
                        <React.Fragment>
                            <PfSubPfSelect
                                onRef={(ref) => (this.pfSelect = ref)}
                                options={{
                                    hideCurrency: true,
                                    hideAllPlatform: true,
                                }}></PfSubPfSelect>
                            <FormControlLabel
                                className={this.props.classes.formControlCheckBox}
                                control={
                                    <Checkbox
                                        checked={this.state.isFilterNonDuplicatedIP}
                                        onChange={(event) => {
                                            this.setState({
                                                isFilterNonDuplicatedIP: event.target.checked,
                                            })
                                        }}
                                        name="checked"
                                        color="primary"
                                    />
                                }
                                label={this.t('duplicatedIp')}
                            />
                        </React.Fragment>
                    ) : this.state.searchType === 'account' ? (
                        <TextField
                            label={this.t('account')}
                            placeholder={this.t('enterAccountEntirely')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={this.state.pfAccount}
                            onChange={(event) =>
                                this.setState({
                                    pfAccount: event.target.value,
                                })
                            }
                            className={this.props.classes.textField}
                        />
                    ) : (
                        this.state.searchType === 'ip' && (
                            <TextField
                                label={this.t('ip')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.ip}
                                onChange={(event) =>
                                    this.setState({
                                        ip: event.target.value,
                                    })
                                }
                                className={this.props.classes.textField}
                            />
                        )
                    )}
                    <DateSelect onRef={(ref) => (this.dateSelect = ref)}></DateSelect>
                    <FormControl className={this.props.classes.formControl} style={{ minWidth: '120px' }}>
                        <InputLabel htmlFor="age-simple">{this.t('device')}</InputLabel>
                        <Select
                            value={this.state.device}
                            onChange={(event) => {
                                this.setState({
                                    device: event.target.value,
                                })
                            }}>
                            <MenuItem value="all">{this.t('Device.all')}</MenuItem>
                            <MenuItem value="pc">{this.t('Device.pc')}</MenuItem>
                            <MenuItem value="mobile">{this.t('Device.mobile')}</MenuItem>
                        </Select>
                    </FormControl>
                    <Button
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        onClick={() => {
                            this.queryData()
                        }}
                        disabled={this.state.isLoading}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Table ownerName="MemberLoginHistoryPage" columns={this.columns} options={this.options} onRef={(ref) => (this.table = ref)} />
                </Grid>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        formControlCheckBox: {
            margin: theme.spacing(1),
            width: '120px',
        },
        textField: {
            margin: theme.spacing(1),
            width: '210px',
        },
        button: {
            minWidth: 95,
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
    }
}

MemberLoginHistoryPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default hoc(styles)(MemberLoginHistoryPage)
